import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import { teal, orange } from '@mui/material/colors';
import CardHeader from '@mui/material/CardHeader';
import { 
  selectResults
} from '../../store/features/transmissionSlice';

const TransmissionPage = () => {
  const dispatch = useDispatch();
  const results = useSelector(selectResults);

  useEffect(() => {
    const chatContainer = document.getElementById('transmission-chat-container')
    if (chatContainer) {
      chatContainer.scrollTo({
        top: chatContainer.scrollHeight - chatContainer.clientHeight,
        behavior: 'smooth'
      })
    }
  }, [results])

  return (
    <>
      <Grid container component={Paper} sx={{ backgroundColor: '#f5f5f0', color: '#fff', overflowY: 'auto', justifyContent: 'flex-end'}}>
        <Grid id="transmission-chat-container" flex={1} item xs={12}>
          {results.map((e: any, index: number) => (
            <Grid container key={index}>
              <Grid
                item
                xs={12}
                sx={{
                  backgroundColor: '#f5f5f5',
                  color: '#000',
                  textAlign: 'left'
                }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: teal[100] }}>H</Avatar>
                  }
                  title={e.question}
                />
              </Grid>
              <Grid
                item xs={12}
                sx={{
                  backgroundColor: '#f5f5f5',
                  color: '#000',
                  textAlign: 'left'
                }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: orange[500] }}>AI</Avatar>
                  }
                />
                <Grid container key={index}
                  justifyContent="center"
                  alignItems="center">  
                  <Grid item xs={11}
                    sx={{
                      backgroundColor: '#f5f5f5',
                      color: '#000',
                      textAlign: 'left',
                      px: 1
                    }}>
                    <div id={index.toString()}>
                      {e.type === 'chat' && (
                        <div>
                          {typeof e.answer === 'string' ? (
                            <div>{e.answer}</div>
                          ) : (
                            <div>
                              {/* Handle new response format with response_type and response_data */}
                              {e.answer && Array.isArray(e.answer) && e.answer.length > 0 && (
                                <>
                                  {(e.answer[0].response_type === 'vector_db' || e.answer[0].response_type === 'web_search' || e.answer[0].response_type === 'text') && e.answer[0].response_data && (
                                    <div dangerouslySetInnerHTML={{ __html: e.answer[0].response_data }} />
                                  )}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                      
                      {e.type === 'error' && (
                        <div style={{ color: 'red' }}>{e.answer}</div>
                      )}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
}

export default TransmissionPage; 